module.exports = __webpack_public_path__ + "static/media/redHome.a4102809.svg";